enum UserRoleType {
  Admin = 1,
  VenueEditor = 2,
  CommerceEditor = 3,
  Buyer = 4,
  FranchiseEditor = 5,
  WarehouseEditor = 6,
}

export default UserRoleType;
